"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KwpProtocols = void 0;
exports.sendFastInit = sendFastInit;
exports.parseKeyBytes = parseKeyBytes;
const constants_1 = require("./constants");
const delay_1 = require("./delay");
const lineControl_1 = require("./lineControl");
exports.KwpProtocols = {
    Kwp2000: "kwp2000",
    Kwp1281: "kwp1281"
};
async function sendFastInit(transport, options = {}) {
    const { setDtr = false, useLLine = false, breakDurationMs = constants_1.FAST_INIT_BREAK_MS, idleDurationMs = constants_1.FAST_INIT_IDLE_MS } = options;
    await (0, lineControl_1.withLineControl)(transport, {
        setDtr,
        setRts: useLLine,
        sendPulse: async (pulseTransport) => {
            await pulseTransport.sendPulse?.(0x02, 2, breakDurationMs, setDtr, useLLine);
        }
    }, async () => {
        await transport.setBreak(breakDurationMs);
        await (0, delay_1.delay)(idleDurationMs);
    });
}
function parseKeyBytes(response) {
    if (response.length < 2) {
        throw new Error("Key bytes response must include at least 2 bytes");
    }
    return response[1] === constants_1.KWP_KEYBYTE_KWP2000
        ? exports.KwpProtocols.Kwp2000
        : exports.KwpProtocols.Kwp1281;
}
//# sourceMappingURL=fastInit.js.map